import React from "react";
import {BaseThatsMeIconProps} from "../../interfaces/baseThatsMeIconProps.interface";
import {useTheme} from "@mui/material";

export default (props: BaseThatsMeIconProps) => {
    const theme = useTheme()
    const {size = 24, fill = theme.palette.thatsMe.iconHeart, ...rest} = props;
    return <svg width={size} height={size} viewBox="0 0 54 50" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
        <path
            d="M24.7524 6.21709C23.4397 4.8774 21.8737 3.81213 20.1455 3.0833C18.4173 2.35446 16.5614 1.9766 14.6858 1.9717C12.8102 1.9668 10.9523 2.33496 9.22036 3.05477C7.48837 3.77457 5.91683 4.83164 4.59717 6.16446C-0.955619 11.7732 -0.929303 20.8886 4.64981 26.5236L25.2984 47.3795C26.1537 48.2446 27.5419 48.2446 28.3972 47.3795L48.9406 26.642C51.6041 23.921 53.091 20.2619 53.0806 16.4543C53.0701 12.6467 51.5631 8.99579 48.8847 6.28946C47.5702 4.94799 46.002 3.88138 44.2714 3.15173C42.5408 2.42207 40.6824 2.04394 38.8042 2.03935C36.9261 2.03476 35.0658 2.40379 33.3317 3.12498C31.5975 3.84616 30.0242 4.90509 28.7031 6.24012L26.7426 8.22373L24.7524 6.21709Z"
            fill={fill}/>
    </svg>
}
